import Icons08 from "assets/icons/icons-08.svg";
import Icons07 from "assets/icons/icons-07.svg";
import Icons10 from "assets/icons/icons-10.svg";
import Icons06 from "assets/icons/icons-06.svg";
import Icons11 from "assets/icons/icons-11.svg";
import Icons15 from "assets/icons/icons-15.svg";
import Icons13 from "assets/icons/icons-13.svg";
import Icons14 from "assets/icons/icons-14.svg";
import Icons12 from "assets/icons/icons-12.svg";

import Icons05 from "assets/icons/icons-05.svg";
import Icons17 from "assets/icons/icons-17.svg";
import Icons16 from "assets/icons/icons-16.svg";
import Icons01 from "assets/icons/icons-01.svg";

import Icons21 from "assets/icons/icons-21.svg";
import Icons22 from "assets/icons/icons-22.svg";
import Icons23 from "assets/icons/icons-23.svg";

export const StatsData = [
  {
    title: "120+",
    subtitle: "Pharmacies onboarded",
  },
  {
    title: "5 States",
    subtitle: "Geographical Reach",
  },
  {
    title: "Rs. 5Cr+",
    subtitle: "Revenue Captured",
  },
  {
    title: "100,000+",
    subtitle: "Digital Bill Processed",
  },
  {
    title: "21,000+",
    subtitle: "End-Customer Connected",
  },
];

export const WhyUseRaseetData = [
  {
    icon: Icons08,
    title: "Get Your Online Store",
    content:
      "Get a fully functional e-store with e-catalog, custom offers & promotions, online payment integrations, loyalty programs, and a lot more",
  },
  {
    icon: Icons07,
    title: "Instant bill receipts",
    content:
      "Send instant bill receipts to your customers over SMS or Whatsapp",
  },
  {
    icon: Icons11,
    title: "More Sale",
    content:
      "Raseet attracts new customers, especially the tech-savvy new generation who wants to order at the ease of sitting at their home.",
  },
  {
    icon: Icons14,
    title: "Sell Beyond Medicines",
    content:
      "Become a one-stop-shop by providing customers with services like doctor consultation, ambulance service, supplements, lab tests, etc.",
  },
  {
    icon: Icons12,
    title: "Earn Extra Income",
    content:
      "Connect your customers with trusted healthcare and wellness service providers and earn a commission",
  },
  {
    icon: Icons10,
    title: "Smooth Analysis",
    content:
      "No more need of maintaining a pile of books to keep records,     everything will be digital and you get great analytics of your       business",
  },
  {
    icon: Icons15,
    title: "Money Saving",
    content: (
      <>
        Save huge bucks by not spending on printers and printing rolls every
        month.{" "}
        <a href="/check-your-savings" rel="noreferrer">
          Click here
        </a>{" "}
        to calculate your useless expenditure on paper bills."
      </>
    ),
  },
  {
    icon: Icons06,
    title: "Customer-centric",
    content:
      "Raseet provides informative   customised content to the end-customers which help in their overall health betterment.",
  },
  {
    icon: Icons13,
    title: "Keeps you informed",
    content:
      "Give every news update about your pharmacy to your customers and establish better customer engagement",
  },
];

export const HowDoesItWorkData = [
  {
    img: Icons05,
    title: "Let us know",
    content: (
      <>
        Reaching us is easy as a-b-c <br />
        <br /> Fill{" "}
        <a
          href="https://9s1s0kitzr0.typeform.com/to/xWpZhy65"
          target="_blank"
          rel="noreferrer"
        >
          this
        </a>{" "}
        simple form and we will schedule a demo as per your convenience
      </>
    ),
  },
  {
    img: Icons16,
    title: "Get Onboarded",
    content: (
      <>
        We are the only non-intrusive solution and do not need any API
        integration with your accounting software. With 256-bit SSL encryption,
        your data stays safe with you. Raseet only gets access to the data
        printed in the digital bills.
        <br />
        <br />
        And the setup takes less time than what it would take for you to read
        this! After all, your time is valuable.
      </>
    ),
  },
  {
    img: Icons17,
    title: "Start Serving Your Customers",
    content: (
      <>
        Keep doing things as you were before, but better! No need tolearn
        anything new to operate with Raseet.
        <br />
        <br />
        Your customers get the digital bills as they would get the printed ones.
        Just ask them to share their phone numbers- that's all you need!
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "50px 0",
          }}
        >
          <a
            href="https://play.google.com/store/apps/details?id=com.raseetapp"
            target="_blank"
            rel="noreferrer"
          >
            <img src={Icons01} alt="playstore img" width="150" />
          </a>
        </div>
      </>
    ),
  },
];

export const Testimonials = [
  {
    img: Icons21,
    name: "Belpatram Pharmacy",
    location: "Noida, Sector 79",
    content:
      "Raseet has helped us connect with our customers remotely, which was not possible before. We don’t fear online competition anymore!",
  },
  {
    img: Icons22,
    name: "Doc24 Wellness",
    location: "Gaur City, GB Nagar",
    content:
      "We wanted a Loyalty program that could easily work with our current billing software & even be operated by my staff. Raseet is the perfect solution for this!",
  },
  {
    img: Icons23,
    name: "Dharampal Pharmacy",
    location: "Greater Noida",
    content:
      "Our customers kept complaining that we don’t have bank offers. We’re so pleased to have found Raseet. It designs promotions that our customers love!",
  },
];

export const FrequentlyAskedQuestions = [
  {
    question:
      "I have SMS/Email integration in my Billing Software, do I still need Raseet?",
    answer:
      "Yes, you do! The capability of digital invoices in your current platform don't allow you to engage with your customers. This is where Raseet comes in and provides you a seamless channel to connect with your customers and increase your business with them.",
  },
  {
    question: "How do I get Raseet?",
    answer:
      "Just drop us a message or call us and we will do the quick installation with your POS and have Raseet with you in no time.",
  },
  {
    question: "How does it work?",
    answer:
      "Raseet is separately installed with your billing software that should have access to internet connection. After the integration you will get an option to send bills from your billing software itself and access to all other features.",
  },
  {
    question: "What is the cost for using Raseet?",
    answer:
      "Raseet offers different types of customized subscription models according to the pharmacy size. One for everyone!",
  },
  {
    question: "Can I get a demo of Raseet?",
    answer: (
      <>
        Yes, we can surely schedule a demo for you, just reach out to us by
        filling{" "}
        <a
          href="https://9s1s0kitzr0.typeform.com/to/xWpZhy65"
          target="_blank"
          rel="noreferrer"
        >
          this form.
        </a>
      </>
    ),
  },
  {
    question: "Will my data privacy be intruded on?",
    answer:
      "Absolutely not, we are the only non-intrusive solution and do not need any API integration with your accounting software. With 256-bit SSL encryption, your data stays safe with you. You will always be the sole in-charge of your data, and we will only get what's printed in the bill.",
  },
  {
    question: "How much time will it take to set up Raseet?",
    answer:
      "It will be quicker than you can imagine. After all, your time is valuable.",
  },
  {
    question: "Do I need to be tech-savvy to learn Raseet functioning?",
    answer:
      "There is no need to learn anything new to operate with Raseet. Just remember to take your customer’s phone number- that’s it!",
  },
  {
    question: "Do I have to stop printing paper bills completely?",
    answer:
      "It's totally your choice. If you want you can still print your bills as Raseet doesn't interfere with your business in any way.",
  },
  {
    question: "What are the payment methods available?",
    answer:
      "Your customers won't have to worry about carrying cash as we will give options for all the general payment methods like Credit Card, Debit Card, NetBanking, UPI, Wallet (Paytm, PhonePe, Amazon Pay). However, COD is also accepted.",
  },
  {
    question: "How will my products be delivered to my customers?",
    answer:
      "You have 2 options: first, you can deliver the products by appointing a delivery agent by yourself which is the most preferred one. Secondly, your customers can also come and pick up their order as once the package is ready, they are informed by Raseet.",
  },
  {
    question: "Can I start customizable offers on my online store?",
    answer:
      "Yes, you can. At Raseet, we have some predefined templates for offers & promotions which you can manually customize as per your requirement. Also, we provide auto-generated offers & promotions.",
  },
  {
    question: "How will my customers know how to use Raseet?",
    answer: (
      <>
        Our UI is very simple and easy to use. Your customers generally won't
        have any difficulty using Raseet. However, if they have any issues, you
        can explain how to use it to them as you have a better connection with
        your customers. Also,{" "}
        <a
          href="https://www.youtube.com/channel/UCUGn-dRA0ioIa4-9XcxRE9g"
          target="_blank"
          rel="noreferrer"
        >
          click here
        </a>{" "}
        for the 'Raseet for Customers' channel. It has all the useful videos
        that you can share with your customers.
      </>
    ),
  },
  {
    question: "How can I earn a commission?",
    answer:
      "You can earn a commission by connecting your customers with trustworthy healthcare and wellness service providers who offer them affordable packages. When your customer buys the package, you earn a commission.",
  },
  {
    question:
      "What are the healthcare and wellness services I can offer to the customers?",
    answer: (
      <>
        There are a set of healthcare and wellness services that you can offer
        to the customers, such as doctor consultation, ambulance service, lab
        tests, supplements, etc.
      </>
    ),
  },
];
